module.exports = __webpack_public_path__ + "static/img/illustratepic_02.039e527.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/illustratepic_02.png
// module id = IHE5
// module chunks = 1